import React from 'react';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import LogoUrl from '@/shared/images/HyperUp-logo-horizontal-blue.png';
import { useAuth } from '@/shared/controllers/auth/context';
import { useGetSystemInstanceInfo } from '@/shared/services/systemInstance/hooks/use-get-system-instance-info';
const useStyles = makeStyles(() => ({
    colorButton: {
        backgroundColor: '#0066CC',
        color: 'white',
        borderRadius: '0px',
    },
    loginName: {
        fontWeight: 500,
    },
    // Шапка используется и на белом фоне, и внутри чёрного AppBar - поэтому цвет наследуем, а не задаём.
    environmentName: {
        opacity: 0.7,
    },
}));
export const PageHeader = () => {
    const { logout, isAuth } = useAuth();
    const stylesClass = useStyles();
    const { data: systemInstanceInfo } = useGetSystemInstanceInfo(isAuth);
    return (React.createElement(Box, { component: "header", display: "flex", flexGrow: 1, alignItems: "center", height: 64 },
        React.createElement(Box, { mr: 8 },
            React.createElement("a", { href: "/management" },
                React.createElement("img", { src: LogoUrl, alt: "HyperUp logo", width: 140, height: 25 }))),
        React.createElement(Box, { ml: "auto", display: "flex", alignItems: "center" },
            systemInstanceInfo && (React.createElement(Box, { mr: 2, display: "flex", alignItems: "center", style: { gap: 8 } },
                React.createElement(Typography, { variant: "body2", color: "inherit", className: stylesClass.loginName }, systemInstanceInfo.loginName),
                React.createElement(Typography, { variant: "body2", color: "inherit", className: stylesClass.environmentName }, systemInstanceInfo.environmentName))),
            React.createElement(Button, { variant: "contained", className: stylesClass.colorButton, onClick: logout }, "\u0412\u044B\u0445\u043E\u0434"))));
};
